import { render, staticRenderFns } from "./FeeSlotPanel.vue?vue&type=template&id=362f6ea8&scoped=true&"
import script from "./FeeSlotPanel.vue?vue&type=script&lang=js&"
export * from "./FeeSlotPanel.vue?vue&type=script&lang=js&"
import style0 from "./FeeSlotPanel.vue?vue&type=style&index=0&id=362f6ea8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362f6ea8",
  null
  
)

export default component.exports